import Loader from "components/Loader/Loader";
import { useAppDispatch } from "hooks/hooks";
import { selectState, selectExpense, updateExpense, setNewPaymentPopover } from "../../Main/main.slice";
import { useSelector } from "react-redux";
import PaymentRow from "./PaymentRow";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";
import InfoTooltip from "components/Popup/InfoTooltip";
import Popover from "components/Popover/Popover";
import NewPaymentPopover from "../../Main/components/NewPaymentPopover";
import DeletePaymentModal from "./DeletePaymentModal";

const BottomSection = () => {
  const dispatch = useAppDispatch();
  const expenseItem = useSelector(selectExpense);
  const [noteValue, setNoteValue] = useState<string>("");
  const { loading, newPaymentPopover } = useSelector(selectState);

  useEffect(() => {
    if (expenseItem && expenseItem.note !== null) {
      setNoteValue(expenseItem.note);
    } else {
      setNoteValue("");
    }
  }, [expenseItem]);

  const handleNoteBlur = async () => {
    try {
      await dispatch(updateExpense({ expenseId: expenseItem.expenseId, data: { note: noteValue } }));
      toast.success("Napomena troška je uspešno izmenjena.");
    } catch (error) {
      console.error("Error updating payment note:", error);
    }
  }

  return (
    <section className="bottom-section loading-container">
      {(loading || !expenseItem) && <Loader />}
      {expenseItem && (
        <div className="payments">
          <div className="g-grid g-header">
            <div className="row">
              <div className="col capitalize center">Napomena</div>
              <div className="col separator-line"></div>
              <div className="col capitalize center separator-line">Datum</div>
              <div className="col center separator-line">IZNOS</div>
              <div className="col capitalize center">Napomena</div>
              <div className="col"></div>
            </div>
          </div>
          <InfoTooltip tooltip="Nova isplata" classesProp="buttons" element="span">
            <button
              className="btn"
              onClick={(e) => {
                dispatch(setNewPaymentPopover({ isOpen: true }))
              }}
            >
              <FontAwesomeIcon icon={faLongArrowAltDown} />
            </button>
          </InfoTooltip>
          <div className="payments-content">
            <textarea onBlur={handleNoteBlur}
              onChange={(e) => { setNoteValue(e.target.value) }}
              value={noteValue}
            ></textarea>
            <div className="g-grid g-content">
              {expenseItem.payments.map((payment, index) => {
                return (
                  <PaymentRow
                    index={index}
                    payment={payment}
                    key={payment.paymentId} />
                );
              })}
            </div>
          </div>
          <Popover
            isOpen={newPaymentPopover.isOpen}
            onClose={() => { dispatch(setNewPaymentPopover({ isOpen: false })) }}
            title="Nova isplata"
            direction="left"
            arrowStyle={{ top: "42px" }}
            position={{ top: 650, left: 450 }}
          >
            <NewPaymentPopover />
          </Popover>
        </div>
      )}
      <DeletePaymentModal />
    </section>
  );
};

export default BottomSection;
